// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"style_sidebar__25YFu","active":"style_active__3QSo0"};